import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, PropsWithChildren } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { BaseDialog, BaseDialogProps } from '../BaseDialog/BaseDialog';
export type SingleTabBaseDialogProps = Omit<BaseDialogProps<'default'>, 'activeTabName' | 'onTabSelected' | 'children'> & PropsWithChildren & {
  title: string;
};

/**
 * An easier to use version of the BaseDialog if you only want a single tab
 */
export const SingleTabBaseDialog: FunctionComponent<SingleTabBaseDialogProps> = React.memo(props => {
  const $ = _c(12);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let children;
  let remainingProps;
  let title;
  if ($[2] !== t0) {
    ({
      title,
      children,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = children;
    $[4] = remainingProps;
    $[5] = title;
  } else {
    children = $[3];
    remainingProps = $[4];
    title = $[5];
  }
  let t1;
  if ($[6] !== children || $[7] !== title) {
    t1 = () => ({
      general: {
        name: "general",
        title,
        renderContent: () => children
      }
    });
    $[6] = children;
    $[7] = title;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== remainingProps || $[10] !== t1) {
    t2 = <BaseDialog {...remainingProps} activeTabName="general">{t1}</BaseDialog>;
    $[9] = remainingProps;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
});